<template>
    <div>
        <div v-if='computedShowInputBox'>
            <el-input @change='handleInputBlur' v-if='type === "Number"' :placeholder='inputPlaceholder' v-model='value'
                      type='number' size='mini' />
            <el-input @change='handleInputBlur' :placeholder='inputPlaceholder' v-else v-model='value'
                      :autosize='textareaRowInfo'
                      :type='inputBoxType' size='mini' />
        </div>
        <el-date-picker
            size='mini'
            v-if='type === "Date"'
            type='datetime'
            v-model='pickerTimeValue'
            align='right'
            @change='handleTimePickerBlur'
            value-format='yyyy-MM-dd HH:mm:ss'>
        </el-date-picker>
        
        <el-switch
            v-if='type === "Boolean"'
            @change='handleSwitchChange'
            v-model='booleanValue'
            active-color='#13ce66'
            inactive-color='#ff4949'>
        </el-switch>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';

export default defineComponent({
    name: 'ClassEdit',
    emits: ['getNewClassValue'],
    data() {
        return {
            value: undefined,
            pickerTimeValue: '',
            booleanValue: undefined,
            inputPlaceholder: undefined
        };
    },
    
    props: {
        type: {
            type: String
        },
        originValue: {
            type: null
        },
        inputBoxType: {
            type: String,
            default() {
                return 'textarea';
            }
        },
        textareaRowInfo: {
            type: Object,
            default() {
                return { minRows: 10, maxRows: 50 };
            }
        }
    },
    created() {
        this.inputPlaceholder = undefined;
        if (this.type === 'String' || this.type === 'Number' || this.type === 'Any' || !this.type || this.type === '') {
            this.inputPlaceholder = '请输入值';
            this.value = this.originValue;
        } else if (this.type === 'Object' || this.type === 'Pointer') {
            this.inputPlaceholder = '请输入JSON格式字符';
            if (this.originValue) {
                this.value = JSON.stringify(this.originValue, null, 2);
            } else {
                this.value = '{}';
            }
        } else if (this.type === 'Array') {
            this.inputPlaceholder = '请输入数组，元素之间使用“,”符号隔开';
            if (this.originValue) {
                this.value = this.originValue.join(',');
            }
        } else if (this.type === 'Date') {
            this.pickerTimeValue = this.originValue;
        } else if (this.type === 'Boolean') {
            if ('true' === this.originValue) {
                this.booleanValue = true;
            } else if ('false' === this.originValue) {
                this.booleanValue = false;
            } else {
                this.booleanValue = this.originValue;
            }
        }
    },
    computed: {
        computedShowInputBox() {
            if (!this.type || this.type === '') {
                return true;
            }
            return this.type === 'String' || this.type === 'Number' || this.type === 'Array' || this.type === 'Object' || this.type === 'Any' || this.type === 'Pointer';
        }
    },
    methods: {
        async convertValue(value) {
            let newValue = undefined;
            switch (this.type) {
                case 'Object':
                    try {
                        newValue = JSON.parse(value);
                        return newValue;
                    } catch (e) {
                        message.error('请输入JSON字符!');
                        throw e;
                    }
                case 'Number':
                    return parseFloat(value);
                case 'String':
                case 'Any':
                    return value;
                case 'Array':
                    // 通过逗号分隔开
                    if (!value) {
                        return value;
                    }
                    return value.split(',');
                default:
                    return value;
            }
            
        },
        async handleInputBlur(value) {
            let convertedValue = await this.convertValue(value);
            this.submitClassValue(convertedValue);
        },
        handleSwitchChange(value) {
            this.submitClassValue(value);
        },
        submitClassValue(newClassValue) {
            this.$emit('getNewClassValue', newClassValue);
        },
        handleTimePickerBlur() {
            this.submitClassValue(this.pickerTimeValue);
        }
    }
});
</script>

<style scoped lang='css'>

</style>
